import { render } from "./FakeLogo.vue?vue&type=template&id=e53e40a4"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/FakeLogo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e53e40a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e53e40a4', __exports__)) {
    api.reload('e53e40a4', __exports__)
  }
  
  module.hot.accept("./FakeLogo.vue?vue&type=template&id=e53e40a4", () => {
    api.rerender('e53e40a4', render)
  })

}


export default __exports__